export const DEFAULT_FONT_FAMILY: string = "Space Grotesk";
